import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';

export const CardContainer = styled(Card, {
  dynamic: ({
    cssProps: {
      expandedProviderListView,
      enableMapViewHideOption,
      isNewMapViewDataCardDesign,
      isGroupedLocationDrawer,
    } = {},
  }) => ({
    boxShadow: enableMapViewHideOption
      ? 'none !important'
      : '0px 2px 6px rgba(25, 25, 26, 0.16)',
    flex: 'none',
    borderRadius: enableMapViewHideOption ? '0px !important' : '12px',
    border: enableMapViewHideOption
      ? 'none !important'
      : '1px solid $neutralGray2',
    marginTop: '0 !important',

    width: enableMapViewHideOption && !expandedProviderListView && '462px',
    maxWidth: enableMapViewHideOption ? '100%' : '',

    height: 'auto',
    '@media (max-width: 464px)': {
      height:
        !enableMapViewHideOption && !isGroupedLocationDrawer
          ? '210px !important'
          : '',
      maxWidth: enableMapViewHideOption && '375px',
    },
    '&.active': {
      border: enableMapViewHideOption ? 'none !important' : '2px solid #D0F1F5',
    },
    '&.abyss-card-root': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: isNewMapViewDataCardDesign ? '' : 'space-between',
      maxWidth: enableMapViewHideOption ? '100%' : '',
      '@media (max-width: 464px)': {
        maxWidth: enableMapViewHideOption && window.innerWidth,
        marginLeft: enableMapViewHideOption ? '16px' : '',
      },
      padding: 0,
    },
    '.account-icon': {
      width: '48px',
      height: '48px',
    },
    '.abyss-heading-root': {
      fontSize: '$lg',
      fontWeight: 'bold',
      lineHeight: '$lg',
      paddingLeft: '$sm',
      '@media (max-width: 744px)': {
        fontSize: '$sm',
      },
    },
    '.text': {
      fontSize: '$sm',
      lineHeight: '$md',
    },
    '.arrow_forward': {
      width: '12px',
    },
    '.check_circle, .star-icon ': {
      height: '13.33px',
      width: '13.33px',
    },
    '@media (max-width: 744px)': {
      '.location-icon': {
        width: '20px',
      },
      '.bottom-section': {
        padding: '$sm $sm',
        '.abyss-text-root': {
          fontSize: '$xs',
        },
      },
      '.text': {
        fontSize: '$extraSmallText',
        fontWeight: '$medium',
      },
    },
  }),
});

export const GroupedLocationDrawerCardContainer = styled(Card, {
  boxShadow: 'none !important',
  flex: 'none',
  borderRadius: '0px !important',
  border: 'none !important',
  marginTop: '0 !important',

  maxWidth: '100%',

  height: 'auto',
  '@media (max-width: 464px)': {
    height: '',
    maxWidth: '375px',
  },
  '&.active': {
    border: 'none !important',
  },
  '&.abyss-card-root': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxWidth: '100%',
    '@media (max-width: 464px)': {
      maxWidth: '375px',
    },
    padding: 0,
  },
  '.account-icon': {
    width: '48px',
    height: '48px',
  },
  '.abyss-heading-root': {
    fontSize: '$lg',
    fontWeight: 'bold',
    lineHeight: '$lg',
    paddingLeft: '$sm',
    '@media (max-width: 744px)': {
      fontSize: '$sm',
    },
  },
  '.text': {
    fontSize: '$sm',
    lineHeight: '$md',
  },
  '.arrow_forward': {
    width: '12px',
  },
  '.check_circle, .star-icon ': {
    height: '13.33px',
    width: '13.33px',
  },
  '@media (max-width: 744px)': {
    '.location-icon': {
      width: '20px',
    },
    '.bottom-section': {
      padding: '$sm $sm',
      '.abyss-text-root': {
        fontSize: '$xs',
      },
    },
    '.text': {
      fontSize: '$extraSmallText',
      fontWeight: '$medium',
    },
  },
});

export const DataContainer = styled('div', {
  dynamic: ({
    cssProps: { enableMapEnhancements, enableMapViewHideOption } = {},
  }) => ({
    display: enableMapViewHideOption ? 'flex' : 'grid',
    width: '100%',
    fontSize: '0px',
    border: 'none !important',
    flexDirection: 'column',
    height: 'auto !important',
    '@media (max-width: 744px)': {
      display: enableMapViewHideOption ? 'flex' : 'grid',
      width: enableMapViewHideOption
        ? 'auto'
        : enableMapEnhancements && '416px',
    },
    '@media (max-width: 464px)': {
      width: enableMapViewHideOption ? 'auto' : '345px',
    },
  }),
});
export const SnackRole = styled('div', {
  lineHeight: '18px !important',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '148px',
  maxHeight: '32px',
  fontSize: '12px',
  fontWeight: 'bold',
  bottom: '6px',
  '@media (max-width: 464px)': {
    lineHeight: '14px !important',
    width: '114px',
  },
});

export const SkeletonContainerDesktop = styled('div', {
  dynamic: ({ cssProps: { isGroupedLocationDrawer } = {} }) => ({
    width: isGroupedLocationDrawer ? '100%' : '408px',
  }),
  background: 'white',
  boxShadow: '0px 2px 6px rgba(25, 25, 26, 0.16)',
  borderRadius: '12px',
  border: '1px solid $neutralGray2',
  height: '190px',
  padding: '8px 16px',
});

export const SkeletonContainerMobile = styled('div', {
  background: 'white',
  boxShadow: '0px 2px 6px rgba(25, 25, 26, 0.16)',
  borderRadius: '12px',
  border: '1px solid $neutralGray2',
  minHeight: '176px',
  minWidth: '320px',
});

export const NetworkWrapper = styled(Flex, {
  dynamic: ({
    cssProps: { enableMapViewHideOption, expandedProviderListView } = {},
  }) => ({
    marginTop: '0px',
    marginRight: expandedProviderListView ? '6px' : '2px',
    gap: '5px',
    flexWrap: enableMapViewHideOption ? 'nowrap' : 'wrap',
    alignItems: 'center',
    '@media (max-width: 464px)': {
      marginTop: '2px',
    },
  }),
});

export const GroupedPinAvatarDataCard = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  width: '112px',
  height: '112px',
  minWidth: '112px',
  minHeight: '112px',
  borderRadius: '$core.border-radius.full',
  overflow: 'hidden',
  '@media (max-width: 1248px)': {
    width: '72px',
    height: '72px',
    minWidth: '72px',
    minHeight: '72px',
  },
};

export const AvatarDataCard = styled('div', {
  dynamic: ({
    cssProps: {
      expandedProviderListView,
      isGroupedLocationDrawer,
      enableMapViewHideOption,
    } = {},
  }) =>
    isGroupedLocationDrawer
      ? GroupedPinAvatarDataCard
      : {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto',
          width: expandedProviderListView
            ? '128px'
            : enableMapViewHideOption
            ? '80px'
            : '48px',
          height: expandedProviderListView
            ? '128px'
            : enableMapViewHideOption
            ? '80px'
            : '48px',
          minWidth: expandedProviderListView
            ? '128px'
            : enableMapViewHideOption
            ? '80px'
            : '48px',
          minHeight: expandedProviderListView
            ? '128px'
            : enableMapViewHideOption
            ? '80px'
            : '48px',
          borderRadius: expandedProviderListView
            ? '$core.border-radius.full'
            : '50%',
          overflow: 'hidden',
          '@media (max-width: 1247px)': avatarDataCardDesktopStyles(
            isGroupedLocationDrawer,
            expandedProviderListView
          ),
        },
});

const avatarDataCardDesktopStyles = (
  isGroupedLocationDrawer,
  expandedProviderListView
) => ({
  width: isGroupedLocationDrawer ? '72px' : expandedProviderListView && '112px',
  height: isGroupedLocationDrawer
    ? '72px'
    : expandedProviderListView && '112px',
  minWidth: isGroupedLocationDrawer
    ? '72px'
    : expandedProviderListView && '112px',
  minHeight: isGroupedLocationDrawer
    ? '72px'
    : expandedProviderListView && '112px',
});

export const VoiceOnlyText = styled('p', {
  border: '0',
  clip: 'rect(0 0 0 0)',
  height: '1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  userSelect: 'none',
  width: '1px',
});

export const VoiceOnlyTextSpan = styled('span', {
  border: '0',
  clip: 'rect(0 0 0 0)',
  height: '1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  userSelect: 'none',
  width: '1px',
});

export const RatingTextWrapper = styled('div', {
  display: 'inline-flex',
  position: 'relative',
});

export const BrandIconWrapper = styled(Flex, {
  paddingLeft: '$md',
});

export const DataCardAvatarContainer = styled('div', {
  position: 'relative',
});

export const providerNameToolTipStyles = {
  'abyss-tooltip-trigger': {
    maxWidth: '240px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    '@media (max-width: 744px)': {
      maxWidth: '200px',
    },
    '@media (max-width: 464px)': {
      maxWidth: '185px',
    },
  },
};

export const providerNameListViewToolTipStyles = (
  removeTruncatedDataCard: boolean = false
) => ({
  'abyss-tooltip-trigger': {
    ...(removeTruncatedDataCard
      ? {
          display: '-webkit-box',
          '-webkit-line-clamp': '2',
          '-webkit-box-orient': 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }
      : {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textWrap: 'nowrap' as const,
        }),
    '@media (max-width: 744px)': {
      maxWidth: '200px',
    },
    '@media (max-width: 464px)': {
      maxWidth: '185px',
    },
  },
});

export const specialityNameToolTipStyles = (
  enableMapViewHideOption: boolean
) => ({
  'abyss-tooltip-trigger': {
    maxWidth: '155px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    lineHeight: '18px',
    '@media (max-width: 744px)': {
      ...(enableMapViewHideOption && { fontSize: '$smallText' }),
    },
    '@media (max-width: 464px)': {
      maxWidth: '122px',
      ...(!enableMapViewHideOption && { fontSize: '$extraSmallText' }),
      lineHeight: '16px',
      paddingTop: enableMapViewHideOption ? '0px' : '2px',
    },
    '@media (max-width: 390px)': {
      maxWidth: '100px',
    },
  },
});

export const popupSpecialityNameToolTipStyles = {
  'abyss-tooltip-trigger': {
    maxWidth: '150px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontSize: '$sm',
    textWrap: 'nowrap',
    fontWeight: '400',
    '@media (max-width: 464px)': {
      maxWidth: '122px',
      fontSize: '$extraSmallText',
      lineHeight: '16px',
      paddingTop: '2px',
    },
    '@media (max-width: 390px)': {
      maxWidth: '100px',
    },
  },
};

export const addressTextToolTipStyles = {
  'abyss-tooltip-trigger': {
    maxWidth: '250px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    '@media (max-width: 464px)': {
      height: '20px',
      fontSize: '$smallText',
      maxWidth: '175px',
    },
    '@media (max-width: 390px)': {
      maxWidth: '140px',
    },
  },
};

export const addressListViewTextToolTipStyles = (
  expandedProviderListView: boolean,
  enableCompareButtonRelocation: boolean,
  compareToggleOn: boolean
) => ({
  'abyss-tooltip-trigger': {
    maxWidth: expandedProviderListView ? '280px' : '220px',
    ...(enableCompareButtonRelocation &&
      compareToggleOn &&
      relocatedCompareAddressMaxWidthStyles()),
    width: 'auto',
    paddingRight: '4px',
    fontSize: expandedProviderListView ? '18px' : '16px',
    textAlign: 'left',
    textDecoration: 'underline',
    whiteSpace: 'wrap',
    textOverflow: 'ellipsis',
    overflow: '',
    '@media (max-width: 464px)': {
      height: '40px',
      fontWeight: 'normal',
      fontSize: '$smallText',
      maxWidth: '175px',
    },
    '@media (max-width: 390px)': {
      maxWidth: '140px',
    },
  },
});

export const popupAddressTextToolTipStyles = {
  'abyss-tooltip-trigger': {
    padding: '4px 0px 4px 0px',
    fontSize: '$sm',
    maxWidth: '150px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    '@media (max-width: 464px)': {
      height: '20px',
      fontSize: '$smallText',
      maxWidth: '150px',
    },
    '@media (max-width: 390px)': {
      maxWidth: '140px',
    },
  },
};

export const virtualVistsToolTipStyles = (
  enableMapViewHideOption: boolean,
  expandedProviderListView: boolean,
  isGEHAV2: boolean = false
) => ({
  'abyss-tooltip-trigger': {
    color: isGEHAV2 ? '$core.color.brand.100' : '',
    maxWidth: '175px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    ...(enableMapViewHideOption && {
      maxWidth: expandedProviderListView ? '' : '175px',
      lineHeight: expandedProviderListView ? '24px' : '20px',
      '@media (max-width: 744px)': {
        fontSize: '$smallText',
        lineHeight: '18px',
      },
    }),
    '@media (max-width: 464px)': {
      ...(!enableMapViewHideOption && {
        fontSize: '$extraSmallText',
        lineHeight: '16px',
      }),
      maxWidth: '95px',
    },
  },
});

export const providerNameDataCardTextStyles = (
  enableMapViewHideOption: boolean = false,
  shouldWrapName: boolean = false,
  isGehaTheme: boolean = false,
  removeTruncatedDataCard: boolean = false,
  expandedProviderListView: boolean = false
) => ({
  '&.abyss-text-root': {
    color: isGehaTheme ? '$core.color.brand.60' : '',
    whiteSpace:
      shouldWrapName || removeTruncatedDataCard
        ? 'normal !important'
        : 'nowrap !important',
    maxWidth: removeTruncatedDataCard
      ? expandedProviderListView
        ? '800px'
        : '250px'
      : 'auto',
    textOverflow: 'ellipsis',
    overflow: removeTruncatedDataCard ? 'hidden' : 'clip',
    wordBreak: 'break-word' as const,
    overflowWrap: 'break-word' as const,
    textAlign: 'left' as const,
    display: removeTruncatedDataCard ? '-webkit-box' : 'block',
    ...(removeTruncatedDataCard && {
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
    }),
    '@media (max-width: 744px)': {
      maxWidth: '200px',
      ...(enableMapViewHideOption && {
        fontSize: '$md',
        fontWeight: '600',
      }),
    },
    '&:hover': {
      textDecoration: 'none',
      color: '$core.color.brand.60',
    },
  },
});

export const popupContainerDataCardTextStyles = {
  '&.abyss-text-root': {
    paddingTop: '8px',
    marginTop: '8px',
    marginbottom: '-8px',
    maxWidth: '150px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    '@media (max-width: 744px)': {
      maxWidth: '151px',
    },
    '&:hover': {
      textDecoration: 'none',
      color: '$core.color.brand.60',
    },
  },
};

export const displayVirtualVisitStyle = (
  isNewMapViewDataCardDesign: boolean
) => ({
  'abyss-flex-root': {
    display: 'flex',
    borderRadius: '100px',
    border: '1px solid white',
    background: '$core.color.brand.100',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px',
    width: '24px',
    height: '24px',
    position: 'absolute',
    top: '0px',
    left: isNewMapViewDataCardDesign ? '30px' : '36px',
    zindex: 1,
  },
});

export const HeadingWrapper = styled(Layout.Group, {
  dynamic: ({ cssProps: { isGroupedLocationDrawer } = {} }) => ({
    paddingLeft: '8px',
    '@media (max-width: 743px)': {
      paddingLeft: isGroupedLocationDrawer && '0px',
    },
  }),
  cursor: 'pointer',
});

export const HeadingExternalWrapper = styled(Layout.Group, {
  dynamic: ({
    cssProps: { enableMapViewHideOption, expandedProviderListView } = {},
  }) => ({
    cursor: 'pointer',
    gap: '4px',
    paddingLeft: enableMapViewHideOption ? '0px' : '8px',
    marginBottom: enableMapViewHideOption ? '2px' : '8px',
    marginRight: '-4px',
    height: enableMapViewHideOption
      ? expandedProviderListView
        ? 'auto'
        : 'auto'
      : '42px',
    '@media (max-width: 744px)': {
      height: 'auto',
    },
    '.abyss-tooltip-trigger': {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'row',
    },
  }),
});

export const FacilityText = styled(Text, {
  dynamic: ({
    cssProps: {
      expandedProviderListView,
      enableMapViewHideOption,
      removeTruncatedDataCard,
    } = {},
  }) => ({
    '&.abyss-text-root': {
      textOverflow: removeTruncatedDataCard ? '' : 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      fontSize: enableMapViewHideOption
        ? expandedProviderListView
          ? '25.63px'
          : '18px'
        : '20.25px',
      lineHeight: enableMapViewHideOption
        ? expandedProviderListView
          ? '28px'
          : '24px'
        : '24px',
      fontWeight: '600',
      textAlign: 'left',
      textWrap: removeTruncatedDataCard ? '' : 'nowrap',
      maxWidth: enableMapViewHideOption
        ? expandedProviderListView
          ? 'calc((100vw + 200px)/2) '
          : removeTruncatedDataCard
          ? ''
          : ''
        : removeTruncatedDataCard
        ? ''
        : '',
      '@media (max-width: 1247px)': {
        fontSize: enableMapViewHideOption
          ? expandedProviderListView
            ? '20.25px'
            : '18px'
          : '20.25px',
        lineHeight: '24px',
      },
      '@media (max-width: 744px)': {
        fontSize: '18px',
        lineHeight: '24px',
        textOverflow: removeTruncatedDataCard ? '' : 'ellipsis',
        textWrap: removeTruncatedDataCard ? '' : 'nowrap',
      },
    },
  }),
});

export const PriceText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '$sm',
  },
  '@media (max-width: 744px)': {
    '&.abyss-text-root': {
      fontSize: '$smallText',
    },
  },
});
export const PrimarySectionStyle = (isNewMapViewDataCardDesign: boolean) => ({
  padding: isNewMapViewDataCardDesign
    ? '0px  24px 0px 10px'
    : '24px  16px 24px 16px',
  '@media (max-width: 464px)': { padding: '12px  12px 24px 8px' },
});

export const PopupContainerStyle = {
  padding: '0px',
  paddingTop: '4px',
  '@media (max-width: 464px)': { padding: '12px  12px 0px 12px' },
};
export const SecondarySectionStyle = {
  flex: '1',
  marginTop: '-20px',
  padding: '4px 16px 0px 78px',
  '@media (max-width: 464px)': { padding: '4px 12px 0px 76px' },
  borderTop: 'none !important',
};

export const popupSecondarySectionStyle = {
  marginTop: '0px',
  padding: '0px',
  '@media (max-width: 464px)': { padding: '4px 12px 0px 76px' },
  borderTop: 'none !important',
};

export const VirtualVisitPatientStyle = (
  enableMapViewHideOption: boolean = false
) => ({
  ...(!enableMapViewHideOption && {
    paddingTop: '0px',
  }),
  '@media (max-width: 464px)': {
    paddingTop: enableMapViewHideOption ? '0px' : '8px',
    maxWidth: '175px',
  },
  '.abyss-tooltip-trigger': {
    '@media (max-width: 390px)': {
      maxWidth: '100px',
    },
  },
});

export const VirtualVisitPatientStyleGroupedLocation = {
  paddingTop: '16px',
  '@media (max-width: 464px)': {
    maxWidth: '175px',
  },
  '@media (max-width: 1248px)': {
    paddingTop: '0px',
  },
};

export const VirtualVisitStyle = (
  enableMapViewHideOption: boolean = false
) => ({
  ...(!enableMapViewHideOption && {
    paddingTop: '2px',
  }),
  '@media (max-width: 464px)': {
    paddingTop: '6px',
    maxWidth: '100px',
  },
  '.abyss-tooltip-trigger': {
    '@media (max-width: 390px)': {
      maxWidth: '75px',
    },
  },
});
export const RatingText = styled(Text, {
  marginLeft: '3px',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
  gap: '4px',
  '&.abyss-text-root': {
    fontSize: '16',
  },
  '@media (max-width: 744px)': {
    '&.abyss-text-root': {
      fontSize: '$xs',
    },
  },
});
export const UnderlineRatingText = styled(Text, {
  marginLeft: '3px',
  textDecoration: 'underline',
  textUnderlineOffset: '0.25em !important',
  gap: '4px',
  '&.abyss-text-root': {
    fontSize: '16',
  },
  '@media (max-width: 744px)': {
    '&.abyss-text-root': {
      fontSize: '$xs',
    },
  },
});
export const RatingsText = styled(Text, {
  marginLeft: '3px',
  lineHeight: '18px',
  '&.abyss-text-root': {
    marginTop: '-0.8px',
  },
  '@media (max-width: 744px)': {
    '&.abyss-text-root': {
      fontSize: '$xs',
    },
  },
});

export const ResponsiveText = styled(Text, {
  dynamic: ({
    cssProps: {
      isGroupedLocationDrawer,
      enableMapViewHideOption,
      isNewMapViewDataCardDesign,
      isWrapText,
    } = {},
  }) => ({
    fontFamily: '$primary !important',
    '&.abyss-text-root': {
      fontSize:
        isGroupedLocationDrawer || isNewMapViewDataCardDesign ? '14px' : '16px',
      textOverflow: 'ellipsis',
      textWrap: isWrapText ? 'wrap' : 'nowrap',
      overflow: 'hidden',
      maxWidth: '175px',
      '@media (max-width: 464px)': !isGroupedLocationDrawer && {
        fontSize: enableMapViewHideOption ? '$smallText' : '$extraSmallText',
        '-webkit-line-clamp': '1',
        maxWidth: '140px',
        lineHeight: '16px',
      },
    },
    wordBreak: 'break-word',
    variants: {
      ancillarySpeciality: {
        true: {
          '&.abyss-text-root': {
            '-webkit-line-clamp': '1',
            textAlign: 'left',
            maxWidth: '230px',
            display: 'block',
            '@media (max-width: 464px)': {
              maxWidth: '200px',
            },
          },
        },
      },
    },
  }),
});

export const ResponsiveTextSpeciality = styled(Text, {
  dynamic: ({
    cssProps: {
      expandedProviderListView,
      enableMapViewHideOption,
      isGEHAV2,
    } = {},
  }) => ({
    color: isGEHAV2 ? '$core.color.brand.100' : '',
    fontSize: expandedProviderListView && '20.25px',
    lineHeight: expandedProviderListView && '24px',
    fontStyle: expandedProviderListView && 'normal',
    fontWeight: expandedProviderListView && '400',
    '@media (max-width: 984px)': {
      fontSize: expandedProviderListView && '18px',
    },
    '&.abyss-text-root': {
      fontFamily: '$primary !important',
      display: 'block',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '20px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
      maxWidth: enableMapViewHideOption ? '100%' : '175px',
      ...(enableMapViewHideOption && {
        '@media (max-width: 744px)': {
          fontSize: '$sm',
        },
      }),
      '@media (max-width: 464px)': {
        ...(!enableMapViewHideOption && {
          fontSize: '$smallText',
        }),
        '-webkit-line-clamp': '1',
        maxWidth: '140px',
        lineHeight: '16px',
      },
    },
    wordBreak: 'normal',
    variants: {
      ancillarySpeciality: {
        true: {
          '&.abyss-text-root': {
            '-webkit-line-clamp': '1',
            textAlign: 'left',
            maxWidth: '230px',
            display: 'block',
            '@media (max-width: 464px)': {
              maxWidth: '200px',
            },
          },
        },
      },
    },
  }),
});

export const getFlexJustification = (popupContainer: boolean) =>
  popupContainer ? 'space-evenly' : 'space-between';

export const getTextSize = (enablePatientView: boolean) =>
  enablePatientView ? 5 : 4;

export const costIndicatorListView = {
  '@media (max-width: 464px)': {
    paddingTop: '1px',
  },
  '.abyss-text-root': {
    '@media (max-width: 464px)': {
      fontSize: '$extraSmallText !important',
      fontWeight: '700',
      lineHeight: '16px !important',
    },
  },
};

export const MilesButton = styled('div', {
  display: 'flex',
});

export const milesButtonStyles = {
  height: 'auto',
  padding: '0px',
};

export const milesButtonStylesListView = {
  display: 'flex',
  alignItems: 'center',
  top: '-6px',
  'abyss-button-root': {
    padding: '0 4px 12px 2px',
  },
};

export const VirtualVisitLabel = styled(Text, {
  '&.abyss-text-root': {
    color: '$core.color.brand.100',
    fontSize: '16px',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    maxWidth: '175px',
    '@media (max-width: 464px)': {
      fontSize: '$extraSmallText',
      '-webkit-line-clamp': '1',
      maxWidth: '140px',
      lineHeight: '16px',
    },
  },
  wordBreak: 'break-word',
  variants: {
    ancillarySpeciality: {
      true: {
        '&.abyss-text-root': {
          '-webkit-line-clamp': '1',
          textAlign: 'left',
          maxWidth: '230px',
          '@media (max-width: 464px)': {
            maxWidth: '200px',
          },
        },
      },
    },
  },
});

export const NoRatingText = styled(Text, {
  '&.abyss-text-root': {
    color: '#00172F',
    fontSize: '$xs',
    fontStyle: 'italic',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    width: '152px',
    '@media (max-width: 464px)': {
      width: '114px',
    },
  },
  wordBreak: 'break-word',
});

export const UnavailableTextListView = styled(Text, {
  dynamic: ({
    cssProps: {
      expandedProviderListView,
      isGroupedLocationDrawer,
      TabletScreen,
      isGEHAV2,
    } = {},
  }) =>
    isGroupedLocationDrawer
      ? {
          '&.abyss-text-root': {
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: '400',
            color: '#4B4D4F',
            width: '152px',
            letterSpacing: '',
            '@media (max-width: 1248px)': {
              fontSize: '14px',
            },
            '@media (max-width: 464px)': {
              width: '114px',
            },
          },
          wordBreak: 'break-word',
        }
      : {
          '&.abyss-text-root': {
            fontSize:
              expandedProviderListView && !isGroupedLocationDrawer
                ? TabletScreen
                  ? '16px'
                  : '18px'
                : '16px',
            lineHeight: '24px',
            fontWeight: '400',
            color: isGEHAV2 ? '$core.color.brand.100' : '#4B4D4F',
            paddingLeft: expandedProviderListView && '48px',
            width: '152px',
            '@media (max-width: 464px)': {
              width: '114px',
            },
            '@media (max-width: 744px)': {
              fontSize: '14px',
            },
          },
          wordBreak: 'break-word',
        },
});

export const AddressText = styled(Text, {
  dynamic: ({ cssProps: { enableMapViewHideOption } = {} }) => ({
    fontSize: '$md',
    lineHeight: enableMapViewHideOption ? '20px !important' : '15px !important',
    '@media (max-width: 744px)': {
      '&.abyss-text-root': {
        fontSize: enableMapViewHideOption ? '$smallText' : '$xs',
      },
    },
    '@media (max-width: 464px)': {
      '&.abyss-text-root': {
        ...(!enableMapViewHideOption && {
          fontSize: '$smallText',
        }),
        maxWidth: '200px',
      },
      ...(enableMapViewHideOption && { lineHeight: '18px !important' }),
    },
    textOverflow: 'ellipsis',
    ...(!enableMapViewHideOption && { textWrap: 'nowrap' }),
    display: 'inline-block',
    overflow: 'hidden',
    maxWidth: '250px',
    textDecoration: 'underline',
  }),
});

export const GroupedPinAddressText = styled(Text, {
  textWrap: 'wrap !important',
  fontSize: '16px !important',
  textAlign: 'left !important',
  fontWeight: '400 !important',
  lineHeight: '20px !important',
  paddingRight: '8px',
  '@media (max-width: 1248px)': {
    fontSize: '14px !important',
  },
  '&.abyss-text-root': { maxWidth: '100%' },
  textOverflow: 'ellipsis',

  display: 'inline-block',
  overflow: 'hidden',
  maxWidth: '250px',
});

export const additionalAddressTextStyles = (
  expandedProviderListView,
  enableMapViewHideOption,
  tabletScreen,
  popupContainer
) => ({
  marginTop: '0px !important',
  fontSize: popupContainer
    ? '$sm'
    : expandedProviderListView
    ? tabletScreen
      ? '16px'
      : '18px'
    : '',
  fontWeight: enableMapViewHideOption ? '400 !important' : '',
  lineHeight: enableMapViewHideOption ? '20px !important' : '15px !important',
  padding: popupContainer && '0px 10px',
  height: enableMapViewHideOption && '40px',
  overflow: 'visible',
});

export const MilesAndAddressWrapper = styled('div', {
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
  padding: '4px 16px',
  '@media (max-width: 464px)': {
    padding: '2px 12px',
  },
});
export const AddressWrapper = styled('div', {
  marginTop: '2px',
  display: 'flex',
  gap: '4px',
  alignItems: 'flex-start',
  '@media (max-width: 464px)': {
    paddingTop: '2px',
  },
});

export const ProviderCardContent = styled('div', {
  dynamic: ({ cssProps: { enableMapViewHideOption } = {} }) => ({
    '@media (max-width: 744px)': {
      paddingBottom: '0',
    },
    ...(!enableMapViewHideOption && {
      minHeight: '14px',
    }),
    lineHeight: '16px',
    textAlign: 'center',
    gap: '8px',
  }),
});

export const BottomWrapper = styled(Flex, {
  dynamic: ({
    cssProps: { enableMapViewHideOption, expandedProviderListView } = {},
  }) => ({
    padding:
      !expandedProviderListView && enableMapViewHideOption
        ? '16px 0px'
        : !expandedProviderListView && '8px 16px',
    '@media (min-width: 360px) and (max-width: 400px)': {
      padding:
        !expandedProviderListView && enableMapViewHideOption
          ? '0px'
          : '16px 0px',
    },
  }),
  borderTop: '1px solid #CBCCCD',
  flexWrap: 'nowrap',
  span: {
    padding: '$xs 0',
  },
  '.icon-text-container': {
    alignItems: 'center',
  },
  '@media (max-width: 464px)': {
    padding: '8px 12px',
  },
});

export const GroupedPinBottomWrapper = styled(Flex, {
  borderTop: '1px solid #CBCCCD',
  padding: '0px 16px 8px 16px',
  flexWrap: 'nowrap',
  span: {
    padding: '$xs 0',
  },
  '.icon-text-container': {
    alignItems: 'center',
  },
  '@media (max-width: 464px)': {
    padding: '8px 12px',
  },
});

export const BottomWrapperChoosePCP = styled(Flex, {
  dynamic: ({
    cssProps: { isNavigatingMaestro, isNewMapViewDataCardDesign } = {},
  }) => ({
    borderTop: isNewMapViewDataCardDesign ? '1px solid #CBCCCD' : 'unset',
    '.abyss-button-root': {
      ...(isNavigatingMaestro
        ? { width: 'auto', padding: '0px 5px !important' }
        : {}),
    },
  }),
  padding: '5px 16px',
  flexWrap: 'nowrap',
  span: {
    padding: '$xs 0',
    whiteSpace: 'nowrap',
  },
  '.abyss-button-root': {
    width: '128px',
    height: '42px',
    border: '2px solid $core.color.brand.100',
    '@media (max-width: 464px)': {
      height: '28px',
    },
  },
  '@media (max-width: 464px)': {
    padding: '8px 12pxs',
  },
});

export const BottomWrapperChoosePCPGroupedLocation = styled(Flex, {
  padding: '5px 16px',
  flexWrap: 'nowrap',
  gap: '20px',
  span: {
    padding: '$xs 0',
    whiteSpace: 'nowrap',
  },
  '.abyss-button-root': {
    width: '122px',
    height: '32px',
    border: '1px solid $core.color.brand.100',
  },
  '@media (max-width: 464px)': {
    padding: '8px 12pxs',
  },
});

export const Dot = styled('div', {
  height: '4px',
  width: '4px',
  borderRadius: '50px',
  background: '$core.color.neutral.90',
});

export const DirectionButton = styled('button', {
  gap: '4px',
  display: 'flex',
  alignItems: 'center',
});

export const ChooseAsPCPButton = styled(Button, {
  dynamic: ({ cssProps: { isNavigatingMaestro } = {} }) => ({
    ...(isNavigatingMaestro
      ? { width: 'auto', height: 'auto', padding: '2px !important' }
      : {}),
  }),
  fontSize: '$md',
  fontWeight: '600',
  lineHeight: '20px',
  padding: '0px !important',
});

export const nameAndBadgeStyle = (
  popupContainer: boolean,
  expandedProviderListView: boolean | undefined
) => ({
  flex: 1,
  marginLeft: popupContainer ? '0px' : '8px',
  width: expandedProviderListView ? '72%' : '',
  maxWidth: expandedProviderListView ? '' : '325px',
});

export const groupedLocationDrawerNameAndBadgeStyle = () => ({
  flex: 1,
  marginLeft: '8px',
  width: '72%',
  paddingLeft: '8px',
  maxWidth: '325px',
});

export const FlexStyles = (
  popupContainer: boolean,
  expandedProviderListView: boolean | undefined
) => ({
  paddingTop: popupContainer ? '0px' : '10px',
  alignItems: expandedProviderListView ? 'flex-start' : 'flex-end',
  flexDirection: 'column',
  '@media (max-width: 464px)': {
    paddingTop: '3px',
  },
  '.abyss-icon-symbol': {
    width: '16px',
    height: '16px',
    marginTop: '1px',
  },
  '.abyss-text-root': { marginTop: '-1px' },
});

export const costIndicatorStyles = (
  enableMapViewHideOption: boolean = false,
  expandedProviderListView,
  TabletScreen,
  showPcpBadge
) => ({
  marginTop: showPcpBadge ? '-20px' : '0',
  paddingTop: enableMapViewHideOption ? '0px' : '8px',
  '@media (max-width: 464px)': {
    paddingTop: '1px',
    lineHeight: '16px !important',
  },
  '.abyss-text-root': {
    ...(enableMapViewHideOption && {
      '@media (max-width: 744px)': {
        fontSize: '$smallText !important',
      },
      ...(expandedProviderListView && {
        fontSize: TabletScreen ? '16px !important' : '18px !important',
        minWidth: 'max-content',
      }),
    }),
    '@media (max-width: 464px)': {
      ...(!enableMapViewHideOption && {
        fontSize: '$extraSmallText !important',
      }),
      fontWeight: enableMapViewHideOption ? '400' : '700',
    },
  },
});

export const milesTextStyles = {
  '.abyss-text-root': {
    '@media (max-width: 464px)': {
      fontSize: '$extraSmallText !important',
      fontWeight: '700',
      marginLeft: 4,
      marginRight: 4,
      lineHeight: '16px !important',
    },
  },
};

export const popupMilesTextStyles = {
  '.abyss-icon-symbol': {
    marginTop: '4px',
  },
  '.abyss-text-root': {
    marginTop: '2px',
    '@media (max-width: 464px)': {
      marginTop: '5px',
      fontSize: '$extraSmallText !important',
      fontWeight: '700',
      lineHeight: '16px !important',
    },
  },
};

export const TerminationDateIndicatorContainer = styled('div', {
  padding: '0px 8px 0px 8px',
  alignItems: 'center',
  justifyContent: 'center',
});
export const TopAndMiddleBadge = styled('div', {
  padding: '0px 8px 0px 8px',
  alignItems: 'center',
  justifyContent: 'center',
});

export const PlatinumProviderIndicatorContainer = styled('div', {
  margin: '0px 8px 8px 8px',
});

export const InNetworkBadgeContainer = styled('div', {
  padding: '0px 8px 0px 8px',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ImageFlexContainer = styled(Flex, {
  dynamic: ({ cssProps: { popupContainer } = {} }) => ({
    width: popupContainer && '150px',
    justifyContent: popupContainer && 'center',
  }),
});

export const mileAndAddressGap = (showSmartChoice: boolean | undefined) =>
  showSmartChoice ? '3px' : '4px';

export const groupedLocationDrawerSectionStyles = (
  isGroupedLocationDrawerSmallScreen: boolean
) => ({
  width: isGroupedLocationDrawerSmallScreen ? '325px' : '',
  padding: '0px 4px 0px 0px',
});

export const milesAndAddressWrapperStyles = (
  expandedProviderListView: boolean,
  showSmartChoice: boolean | undefined
) =>
  !expandedProviderListView
    ? {
        cursor: 'pointer',
        gap: mileAndAddressGap(showSmartChoice),
      }
    : { padding: '0px', gap: '0px' };

export const relocatedCompareAddressMaxWidthStyles = () => ({
  maxWidth: '150px !important',
  '@media (min-width: 481px) and (max-width: 869px)': {
    maxWidth: '180px !important',
  },
  '@media (min-width: 439px) and (max-width: 480px)': {
    maxWidth: '130px !important',
  },
});

export const MapPopupPremiumCareCardInfo = styled('div', {
  marginLeft: '-12px',
  marginTop: '2px',
});

export const flexSpecialityAndBadgeStyle = (badgeCardType: string) => ({
  width: badgeCardType === 'data-card' ? '100%' : 'auto',
  justifyContent: 'space-between',
});

export const cardBookmarkButtonStyles = (
  mapViewUpdatedChanges: boolean,
  popupContainer: boolean
) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: popupContainer ? 'center' : 'space-between',
  width: mapViewUpdatedChanges ? '100%' : 'auto',
  marginLeft: '0px',
  '@media (max-width: 464px)': {
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
  },
});

export const SmartChoiceListViewAvatar = (
  expandedProviderListView,
  isGroupedLocationDrawer,
  isSmartChoicePractitioner = false
) => ({
  position: 'relative',
  bottom: expandedProviderListView ? '20px' : '12px',
  paddingTop: !isSmartChoicePractitioner ? '4px' : '0px',
  justifyContent: 'center',
  width: expandedProviderListView ? '' : '111px',
  '@media (min-width: 1249px)': {
    height: isGroupedLocationDrawer && '10px',
  },
});

export const GroupedPinSmartChoiceListViewAvatar = {
  position: 'relative',
  bottom: '20px',
  paddingTop: '',
  justifyContent: 'center',
  width: '',
  '@media (min-width: 1249px)': {
    height: '10px',
  },
};

export const MapViewText = styled(Text, {
  dynamic: ({ cssProps: { expandedProviderListView } = {} }) => ({
    fontSize: expandedProviderListView ? '20.25px' : '16px ',
    lineHeight: expandedProviderListView ? '24px' : '20px',
    display: expandedProviderListView ? '' : 'block',
    textWrap: expandedProviderListView ? '' : 'nowrap',
    textOverflow: expandedProviderListView ? '' : 'ellipsis',
    overflow: expandedProviderListView ? '' : 'hidden',
    whiteSpace: expandedProviderListView ? '' : 'nowrap',
    width: expandedProviderListView ? '' : '250px',
    textAlign: 'left',
    fontWeight: '400',
    '@media (max-width: 984px)': {
      fontSize: expandedProviderListView ? '18px' : '16px ',
    },
    '@media (max-width: 744px)': {
      fontSize: '16px',
      lineHeight: '20px',
    },
  }),
});

export const NetworkText = styled(Text, {
  dynamic: ({ cssProps: { expandedProviderListView } = {} }) => ({
    fontSize: expandedProviderListView ? '18px' : '16px ',
    lineHeight: expandedProviderListView && '24px',
    fontWeight: '400',
    '@media (max-width: 984px)': {
      fontSize: expandedProviderListView ? '16px' : '16px ',
    },
    '@media (max-width: 744px)': {
      fontSize: '16px',
      lineHeight: '20px',
    },
    '@media (max-width: 464px)': {
      fontSize: '14px',
      lineHeight: '18px',
    },
  }),
});

export const GroupedLocationDrawerHeaderStyle = {
  'abyss-modal-base-content-container': {
    '@media (min-width: 400px)': {
      maxHeight: '100%',
    },
    '@media (max-width: 400px)': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  'abyss-modal-header-container': {
    paddingBottom: '0px',
    '.abyss-modal-content-title': {
      padding: '8px 0 8px 0',
      fontFamily: '$primary !important',
    },
  },
  'abyss-modal-close-button': {
    zIndex: '999',
  },
};

export const FacilityTagStyle = styled(Flex, {
  dynamic: ({
    cssProps: { isAncillaryCard, expandedProviderListView } = {},
  }) => ({
    paddingRight: isAncillaryCard ? '42px' : '',
    alignItems: expandedProviderListView
      ? 'flex-end'
      : isAncillaryCard
      ? 'flex-end'
      : 'flex-start',
    display: 'flex',
    gap: '4px',
    flex: '1 0 0',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    '@media (max-width: 984px)': {
      paddingRight: isAncillaryCard ? '42px' : '',
    },
    '@media (max-width: 744px)': {
      paddingRight: '0px',
      paddingTop: '4px',
    },
  }),
});

export const FacilityTextStyle = styled(Text, {
  dynamic: ({
    cssProps: {
      expandedProviderListView,
      enableMapViewHideOption,
      isGEHAV2,
    } = {},
  }) => ({
    '&.abyss-text-root': {
      display: enableMapViewHideOption ? 'flex' : 'none',
      marginLeft: expandedProviderListView ? '4px' : '0px',
      fontWeight: '700',
      color: isGEHAV2 ? '$core.color.brand.100' : '#196ECF',
      fontSize: '14px',
      alignItems: 'center',
      borderRadius: '4px',
      backgroundColor: isGEHAV2 ? '#CAD9E2' : '#EDF3FB',
      lineHeight: expandedProviderListView ? '20px' : '18px',
      height: '24px',
      padding: '2px 8px',
      '@media (max-width: 464px)': {
        fontSize: '12px',
        lineHeight: '16px',
      },
    },
  }),
});

export const networkDisplayStyles = (
  expandedProviderListView: boolean | undefined,
  enableMapViewHideOption: boolean | undefined,
  isSmartChoicePractitioner: boolean
) => ({
  paddingTop:
    expandedProviderListView ||
    (!expandedProviderListView && !isSmartChoicePractitioner)
      ? '0px'
      : '10px',
  justifyContent: 'center',
  position: enableMapViewHideOption ? 'relative' : '',
  bottom: enableMapViewHideOption && isSmartChoicePractitioner ? '16px' : '',
});

export const GetStartedFlexStyle = styled(Flex, {
  dynamic: ({ cssProps: { expandedProviderListView } = {} }) => ({
    display: 'flex',
    width: expandedProviderListView ? '20%' : '100%',
    paddingRight: expandedProviderListView ? '42px' : '0px',
    gap: '8px',
    flex: '1 0 0',
    paddingTop: '0px',
    '@media (max-width: 984px)': {
      paddingRight: expandedProviderListView ? '42px' : '0px',
    },
    '@media (max-width: 744px)': {
      paddingRight: '0px',
      width: '100%',
    },
  }),
});

export const NetworkIconStyles = styled(IconSymbol, {
  dynamic: ({
    cssProps: { enableMapViewHideOption, expandedProviderListView } = {},
  }) => ({
    width: enableMapViewHideOption
      ? expandedProviderListView
        ? '20px !important'
        : '16px !important'
      : '13px !important',
    height: enableMapViewHideOption
      ? expandedProviderListView
        ? '20px !important'
        : '16px !important'
      : '13px !important',
    '@media (max-width: 744px)': {
      width: '16px !important',
      height: '16px !important',
    },
    '@media (max-width: 464px)': {
      width: '13px !important',
      height: '13px !important',
    },
  }),
});

export const FacilityIconStyles = styled(IconSymbol, {
  dynamic: ({
    cssProps: { expandedProviderListView, removeTruncatedDataCard } = {},
  }) => ({
    'abyss-icon': {
      overflow: removeTruncatedDataCard
        ? 'visible !important'
        : 'hidden !important',
      margin: '3px 0 4px 4px',
      width: expandedProviderListView ? '24px' : '18px',
      height: expandedProviderListView ? '24px' : '18px',
      '@media (max-width: 984px)': {
        width: '18px',
        height: '18px',
      },
      '@media (max-width: 464px)': {
        width: '15px',
        height: '15px',
      },
    },
  }),
});

export const contactContainerStyles = (
  expandedProviderListView,
  tabletScreenView
) => ({
  display: 'flex',
  alignItems:
    expandedProviderListView && tabletScreenView ? 'flex-end' : 'center',
  border: '1px solid transparent !important',
  paddingRight: expandedProviderListView ? '0' : '48',
  gap: expandedProviderListView && tabletScreenView ? '4px' : '8px',
  marginTop: expandedProviderListView && 'auto',
});

export const NetworkInnerWrapper = styled(Flex, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const getCardSectionWidth = (
  isGroupedLocationDrawer: boolean,
  smallScreen: boolean,
  enableCompareButtonRelocation: boolean,
  compareToggle: boolean,
  largePhoneScreen: boolean,
  isMapView: boolean
): string => {
  if (isGroupedLocationDrawer && smallScreen) return '210px';

  if (enableCompareButtonRelocation && isMapView && compareToggle) {
    return '249px';
  }

  if (enableCompareButtonRelocation && compareToggle && largePhoneScreen) {
    return '212px';
  }

  return '100%';
};

export const cardSectionStyle = (
  isGroupedLocationDrawer: boolean,
  smallScreen: boolean,
  enableCompareButtonRelocation: boolean = false,
  compareToggle: boolean = false,
  largePhoneScreen: boolean = false,
  isMapView: boolean = false
) => ({
  borderTop: 'none !important',
  padding: '4px',
  width: getCardSectionWidth(
    isGroupedLocationDrawer,
    smallScreen,
    enableCompareButtonRelocation,
    compareToggle,
    largePhoneScreen,
    isMapView
  ),
});

export const ProviderReviewDot = styled('div', {
  width: '4px',
  height: '4px',
  borderRadius: '50%',
  backgroundColor: '#4B4D4F',
  marginLeft: '4px',
  marginRight: '4px',
});

export const FlexRatingContainer = styled(Flex, {
  gap: '4px',
  dynamic: ({
    cssProps: {
      enableCompareButtonRelocation = false,
      compareToggle = false,
    } = {},
  }) => ({
    ...(enableCompareButtonRelocation &&
      compareToggle && {
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        '.abyss-rating-root, .abyss-rating-stars-container': {
          flexShrink: 0,
        },
        '.abyss-rating-star': {
          width: '20px',
        },
      }),
  }),
});

export const ResultCard = styled('div', {
  dynamic: () => ({
    width: '100%',
    height: 'auto',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
      "avatar name"
      "avatar content"
    `,
  }),
});

export const RatingsReviewText = styled('span', {
  display: 'inline-block',
  color: '$core.color.neutral.90',
  fontSize: '16px',
  lineHeight: '20px',
  whiteSpace: 'nowrap',
  dynamic: ({
    cssProps: {
      enableCompareButtonRelocation = false,
      compareToggle = false,
    } = {},
  }) => ({
    ...(enableCompareButtonRelocation &&
      compareToggle && {
        flexShrink: 0,
      }),
  }),
});
